module.exports = __webpack_public_path__ + "img/problem-statement.95460e71.png";